/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { login } from "../assets/login";
import { Icon, type IconBaseProps } from "../icon";

export const IconLogin = (props: IconBaseProps) => <Icon {...props} svg={login} />;

IconLogin.displayName = "IconLogin";
